<template>
<div id="dashboard">
<div v-if="!states.viewAllow && !states.showFail" class="loader overlay">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div v-if="states.showFail">
    <p></p>
      <div v-if="states.onServerError" class="text-center">
      <label>Došlo k neočakávanej chybe. Skúste neskôr.</label>
      </div>
      <div v-else>
      <p class="text-center" v-if="tplData.general"><label v-html="tpl('general.errorLoading')"></label></p>
      </div>
  </div>
  <div v-if="states.viewAllow && states.mainView">
      <div class="row">
        <div class="large-12 medium-12 small-12 columns"><p></p>
      <h2>{{msg}}</h2>
      <hr/>
    <p v-show="!baseView.noLimit" v-html="tpl('offer.intro')"></p>
    <p v-show="baseView.noLimit" v-html="tpl('offer.introNoLimit')"></p>
    <div v-for="pcg in eligData" :key="pcg.bucketName" v-bind:class="{ sPkg: !pcg.oappOnly, sPkgPass: pcg.oappOnly }">
      <div class="sub-content pcg-list" v-on:click="pcgVis(pcg.bucketName)">
        <div class="pcg-block-left">
          <div class="radio">
            <span v-bind:class="{ checked: pcg.isChecked}"><input type="radio"></span>
          </div>
        </div>
        <div class="pcg-block-right">
        <span>
        <span class="pcg-title">{{pcg.readable}}<br/></span>
                <div v-html="pcg.newDesc.infoText" style="width:82%"></div>
        </span>
        <span class="pcg_right" v-html="formatPrice(pcg.price, !pcg.isActive)">
        </span>
        </div>
      </div>
        <div v-show="pcg.isChecked" class="pkg_container">
        <div class="pkg_desc">
          <span class="fet" v-show="pcg.isActive" v-html="pcg.newDesc.currStateText"></span>
          <div v-html="pcg.newDesc.longText"></div>
          <p></p>
          <div v-show="!pcg.oappOnly">Platí do <strong><span v-html="pcg.newDesc.valText"></span></strong></div>
        </div>
        <a class="a_btn" v-show="pcg.newDesc.startAction" v-bind:class="{ a_action: !pcg.oappOnly, a_info: pcg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=pcg.bucketName" v-html="pcg.btnText"></a>
        </div>
      </div>

      <p>&nbsp;</p>
      <div v-show="!baseView.noLimit">
        <hr>                            
            <router-link to="/balicky" class="rAnchor"><span class="inline mActive fet">VŠETKY DOPLNKOVÉ BALÍČKY</span>
            <img class="rightIco right inline" src="graphics/ico_arrow_next.png"/>
            </router-link>
        <p></p>
        <hr> 
      </div>
      </div>
    </div>
  </div>
  <activations v-if="states.activationsView" :states="states" :productdetail="productdetail" :tplData="tplData" :pkgDef="eligData" :nextPacks="baseView.nextPacks"></activations>
</div>
</template>

<script>
import moment from 'moment'
import Activations from '@/components/balickyaction'
import pkgDef from '@/assets/js/pkgDef'

export default {
  name: 'Ponuka',
  components: {
    Activations
  },
  data () {
    return {
      msg: 'PONUKA',
      seen: false,
      tplData: {},
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      states: {
        viewAllow: false, showFail: false, directAction: 'stopProl', isDirect: false, activationsView: false, mainView: true, onServerError: false
      },
      baseView: {
        nextPacks: [], noLimit: false, defaultCount: 3
      },
      msisdn: '',
      productdetail: {},
      pkgDef: pkgDef,
      eligData: []
    }
  },
  created: function() {
    var that = this

    if (document.getElementById("msisdnTextSpan") === null) {
      var msisdnTextSpan = document.createElement("span")
      msisdnTextSpan.id = "msisdnTextSpan"
      var msisdnTemp = document.getElementById("jsHolder")
      msisdnTemp.appendChild(msisdnTextSpan)
    }  else {
      var msisdnTextSpan = document.getElementById("msisdnTextSpan")
    }

    var productDetailAllow = false, tplDataAllow = false;

    if (_.isEmpty(this.$store.state.productdetail)) {
      that.$store.dispatch('refreshProductDetail').then(() => {
       if (that.$store.state.httpCodes.productdetail === 200) {
          that.productdetail = that.$store.state.productdetail
          that.msisdn = that.$store.state.productdetail.msisdn
          msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
       }        
       if (that.$store.state.httpCodes.productdetail === 403) {
          window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
       } else if (that.$store.state.httpCodes.productdetail === 400) {
          window.location.href = '/spotreba'
       } else if (that.$store.state.httpCodes.productdetail === 502) {
          that.states.showFail = true
          that.states.onServerError = true
       } else if (_.isEmpty(that.productdetail)) {
            that.states.showFail = true
       } else {
            productDetailAllow = true
            if (tplDataAllow) {
              this.setPecka()
            }
          }
      })
    } else {
        that.productdetail = that.$store.state.productdetail
        that.msisdn = that.$store.state.productdetail.msisdn
        msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
        that.states.viewAllow = true
    }
    if (_.isEmpty(this.$store.state.tplData)) {
      that.$store.dispatch('refreshTplData').then(() => {
        that.tplData = that.$store.state.tplData
        tplDataAllow = true
        if (productDetailAllow) {
          this.setPecka()
      }
      });
    } else {
        that.tplData = that.$store.state.tplData
        this.setPecka()
    }
  },
  methods: {
    formatMsisdn: function(virgin) {
      return '0' + String(virgin).substring(3)
    },
    httpEligible: async function() {
      let a 
      this.states.viewAllow = false
      await this.$http.get(this.$store.state.elgSrc)
      .then(function (resp) {
         a = { data: resp.data, status: resp.status }
      })
      .catch(function(err){
         a = { data: err.response.data, status: err.response.status }
      })
      return a
    },
    setPecka: async function() {
      var that = this

      var eligData = await this.httpEligible(), currCount = 0, eligDataProc = []
      this.pkgDef = this.pkgDef.tkarta
      this.eligData = []
      var daysAcc = ['nedele', 'pondelka', 'utorka', 'stredy', 'štvrtka', 'piatka', 'soboty']
      var daysNom = ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota']
      this.states.daysAcc = daysAcc

      if ((eligData.status == 200) && (((this.productdetail.product.productName).toLowerCase()).indexOf('t karta') !== -1)) {
        this.states.viewAllow = true
        this.msg = "PONUKA PRE " + this.formatMsisdn(this.productdetail.msisdn)
        if (_.isArray(eligData.data)) {
          if (!_.isEmpty(eligData.data)) {
            var ePrioData = _.clone(eligData.data)
            var hasPrioDef = false
            if (!_.isUndefined(ePrioData[0].priority)) {
              ePrioData = _.sortBy(ePrioData, [function(o) { return o.priority; }]);
              hasPrioDef = true
            }
            _.forEach(ePrioData, function(dv, dk){
                if ((currCount >= (parseInt(that.tplData.offer.maxCount) || that.baseView.defaultCount)) && (!that.baseView.noLimit)) {
                  return false
                }
              _.forEach(that.pkgDef, function(tv, tk){
                if (dv.bucketName == tv.offerBName) {

                  if (that.tplData.package) {
                    tv.desc = that.tplData.package[(tv.bucketName.toLowerCase().replace(/ /g, ''))]
                    if (!tv.readable) {
                      var bName = tv.bucketName
                      if ((/free data social/i).test(bName)) {
                        bName = "FD-SOCIAL"
                      }
                      if ((/free data chat/i).test(bName)) {
                        bName = "FD-CHAT"
                      }
                      tv.readable = that.tplData.package.name[bName] || bName
                    }
                  }

                  tv.price = dv.price
                  tv.priority = dv.priority
                  tv.newDesc = {}
                  tv.newDesc = _.clone(tv.desc)
                  tv.newDesc.currStateText = "AKTÍVNY"
                  if (that.$route.query.override == "1") {
                    if (tv.oappOnly) {
                      tv.btnText = "Aktivovať"
                    }
                    tv.oappOnly = false
                  }
                  if (tv.oappOnly && that.tplData.package) {
                    tv.newDesc.longText = "<strong>" + that.tplData.package.oappText + "</strong>"
                  }
                  if (tv.paralellDaysAdd == 0) {
                  tv.newDesc.valText = 'dnes, '+ daysNom[(moment(that.productdetail.timeStamp).format('d'))] +' '+ moment(that.productdetail.timeStamp).format('D.M.YYYY') + " 23:59"
                  } else {
                  tv.newDesc.valText = daysAcc[(moment(that.productdetail.timeStamp).add((tv.paralellDaysAdd || 0), 'days').format('d'))] + ', ' + moment(that.productdetail.timeStamp).add((tv.paralellDaysAdd || 0), 'days').format('D.M.YYYY H:mm')
                  }
                  if ((!hasPrioDef) || (dv.priority !== undefined)) {
                    eligDataProc.push(tv)
                    currCount ++
                  }
                  tv.newDesc.startAction = true
                }
              })
            })
            this.eligData = eligDataProc

            if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage' }))) {
              var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage' })[0]
              if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
                if (dpIdent.buckets.name.indexOf("SURF1") === -1)  {
                  that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
                }
              }
            }

            if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage2' }))) {
              var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage2' })[0]
              if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
                that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
              }
            }

            if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage3' }))) {
              var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage3' })[0]
              if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
                that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
              }
            }

            if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackagePD' }))) {
              var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackagePD' })[0]
              if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
                that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
              }
            }

            if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackageSSD' }))) {
              var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackageSSD' })[0]
              if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
                that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
              }
            }


            if (!_.isEmpty(that.filterDataBouquet())) {
              _.forEach(that.filterDataBouquet(), function(v){
                var currPkg = _.filter(that.pkgDef, { 'bucketName': v.name })[0]
                if (!_.isEmpty(currPkg)) {

                  currPkg.newDesc.currStateText = "AKTÍVNY"
                  if (!_.isEmpty(v.nextChargeDate)) {
                    if (moment(v.nextChargeDate) > moment(that.productdetail.timeStamp)) {
                        currPkg.newDesc.valText = daysAcc[(moment(v.nextChargeDate).format('d'))] + ', ' + moment(v.nextChargeDate).format('D.M.YYYY H:mm')
                        currPkg.hasNext = true
                    }
                  } else {
                      currPkg.newDesc.valText = daysAcc[(moment(v.endDate).format('d'))] + ', ' + moment(v.endDate).format('D.M.YYYY H:mm')
                  }
                  currPkg.isActive = true
                  if (!currPkg.paralellPack) {
                    currPkg.newDesc.startAction = false
                  }
                }
              })
            }
            var calls2NumPkgCheck = _.filter(this.eligData, { 'bucketName': 'FreeCalls2Num' })
            if ((!_.isEmpty(this.getFreeCalls2Num())) && (!_.isEmpty(calls2NumPkgCheck))) {
              var freeCalls2Num = this.getFreeCalls2Num(), nDates = [], nArr = [], that = this
              var calls2NumPkg = calls2NumPkgCheck[0]
              calls2NumPkg.newDesc.currStateText = "AKTÍVNY"
              calls2NumPkg.isActive = true
              _.forEach(freeCalls2Num, function(nv,nk){
                nv.computedVal = moment(nv.endDate || nv.nextChargeDate)
                if (nv.nextChargeDate && (moment(nv.nextChargeDate) > moment(that.productdetail.timeStamp))) {
                  calls2NumPkg.prolongable = true
                }
              })
              freeCalls2Num = _.reverse(_.sortBy(freeCalls2Num, [function(o) { return o.computedVal; }]));
              calls2NumPkg.numSorted = freeCalls2Num
              calls2NumPkg.newDesc.valText = daysAcc[(freeCalls2Num[0].computedVal.format('d'))] + ', ' + freeCalls2Num[0].computedVal.format('D.M.YYYY H:mm')
              if (freeCalls2Num.length >= 5) {
                calls2NumPkg.btnText = 'Nastavenie'
              }
            }
            if (!_.isEmpty(that.baseView.nextPacks)) {
              _.forEach(that.baseView.nextPacks, function(v){
                v.name = v.buckets.name

                if ((/30d_1gb/i).test(v.name)) {
                  v.name = "30D_1GB"
                }
                if ((/30d_3gb/i).test(v.name)) {
                  v.name = "30D_3GB"
                }
                if ((/30d_4gb/i).test(v.name)) {
                  v.name = "30D_4GB"
                }
                if ((/30d_5gb/i).test(v.name)) {
                  v.name = "30D_5GB"
                }
                if ((/30d_6gb/i).test(v.name)) {
                  v.name = "30D_6GB"
                }
                if ((/30d_10gb/i).test(v.name)) {
                  v.name = "30D_10GB"
                }
                if ((/10d_unltd/i).test(v.name)) {
                  v.name = "10D_UnLtd"
                }
                if ((/10d_chat/i).test(v.name)) {
                  v.name = "10D_CHAT"
                }
                if ((/10d_social/i).test(v.name)) {
                  v.name = "10D_SOCIAL"
                }
                if ((/free data social/i).test(v.name)) {
                  v.name = "FD-SOCIAL"
                }
                if ((/free data chat/i).test(v.name)) {
                  v.name = "FD-CHAT"
                }
                if ((/10d_1gb/i).test(v.name)) {
                  v.name = "10D_1GB"
                }
                if ((/dc300/i).test(v.name)) {
                  v.name = "DC300"
                }
                if ((/freecalls21/i).test(v.name)) {
                  v.name = "FreeCalls21N"
                }
                var currPkg = _.filter(that.eligData, { 'bucketName': v.name })[0]
                if (!_.isEmpty(currPkg)) {
                  currPkg.isActive = true
                  if (currPkg.paralellDaysAdd == 0) {
                    currPkg.newDesc.valText = 'dnes, '+ daysNom[(moment(that.productdetail.timeStamp).format('d'))] +' '+ moment(that.productdetail.timeStamp).format('D.M.YYYY') + " 23:59"
                    } else {
                    currPkg.newDesc.valText = daysAcc[(moment((v.buckets.endDate) || (v.buckets.nextChargeDate)).format('d'))] + ', ' + moment((v.buckets.endDate) || (v.buckets.nextChargeDate)).format('D.M.YYYY H:mm')
                    }
                  currPkg.btnText = "Dokúpiť teraz"
                  currPkg.newDesc.currStateText = "AKTÍVNY"
                  if ((currPkg.prolongable) && (v.buckets.nextChargeDate && (moment(v.buckets.nextChargeDate) > moment(that.productdetail.timeStamp)))) {
                    currPkg.hasNext = true
                  }
                  if (!currPkg.paralellPack) {
                    currPkg.newDesc.startAction = false
                  }
                }

              })
            }
            that.pcgVis(eligDataProc[0].bucketName)
          }
        }
      } else {
        this.$router.replace({ path: '/balicky' })
        this.states.viewAllow = true
      }      
    },    
    filterDataBouquet: function () {
      var that = this
      var targetObj = {}, res = [], namesList = ['Free Data SOCIAL', 'Free Data CHAT', 'StreamOn Data Unlmtd', 'Free Voice Onnet', 'Free SMS SK']
      var wallets = this.productdetail.product.subscriberWallets
      if (!Array.isArray(wallets)) {
        wallets = [wallets]
      }
      wallets.forEach(function(v){
        if (v.type === undefined) {
          targetObj = v;
        }
      })
      if (!Array.isArray(targetObj.buckets)) {
        targetObj.buckets = [targetObj.buckets]
      }
      targetObj.buckets.forEach(function(tv){
        if (namesList.indexOf(tv.name) !== -1) {
          if (moment(that.productdetail.timeStamp) < moment(tv.endDate || tv.nextChargeDate)){
              res.push(tv)
          }
        }
      })
      return res
    },
    getFreeCalls2Num: function () {
      var that = this
      var targetObj = {}, res = []
      var wallets = this.productdetail.product.subscriberWallets
      if (!Array.isArray(wallets)) {
        wallets = [wallets]
      }
      wallets.forEach(function(v){
        if (v.type === undefined) {
          targetObj = v;
        }
      })
      if (!Array.isArray(targetObj.buckets)) {
        targetObj.buckets = [targetObj.buckets]
      }
      targetObj.buckets.forEach(function(tv){
        if ((tv.name).toLowerCase().indexOf("freecalls2num") !== -1) {
          if (moment(that.productdetail.timeStamp) < moment(tv.endDate || tv.nextChargeDate)){
              res.push(tv)
          }
        }
      })
      return res
    },
    pcgVis: function(currPkg) {
      var getResize = document.getElementById('containerMain'), tLen = this.eligData.length
      var that = this
      _.forEach(this.eligData, function(pv, pk){
        if (pv.bucketName == currPkg) {
          pv.isChecked = !pv.isChecked
          if (pv.isChecked) {
            setTimeout(function(){
            if ((pk + 1) >= tLen) {
                document.getElementById('main').scrollBy(0, 140);
            }   
            }, 300)
            that.states.currPkg = pv
            that.states.pkgAction = pv.bucketName
          } else {
            getResize.style.paddingBottom = '0'            
          }
        } else {
          pv.isChecked = false
        }
      })
    },    
    callAction: function(pAction) {
      if (this.states.currPkg.oappOnly) {
        window.location = "https://telekomsk.page.link/JioD"
      } else {
      this.states.activationsView = true
      this.states.directAction = pAction
      this.states.isDirect = true
      }
    },
    formatPrice: function (virgin, active) {
        return parseFloat(virgin).toFixed(2).toString().replace(/\./, ',') + " €"
    }
  }
}
</script>

<style scoped> 
.fet {
   color: #E20074;
 }

.pcg-sub {
  border: 1px solid #E20074;
  position: relative;
  margin-bottom: 2rem;
}

.sub-content {
  width: 100%;
  display: flex;
  padding: 10px;
}

.pcg-sub .sub-heading {
  width: 100%;
  line-height: 2.4rem;
  color: #ffffff;
  background-color: #E20074;
  padding: 0 10px;
  font-size: 1.2rem;
  font-weight: bold;
}

.sPkg {
  margin-bottom: 1rem;
  position: relative;
  background-color: #ededed;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset
}

.sPkgPass {
  margin-bottom: 1rem;
  position: relative;
  background-color: #f5f5f5;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset;
  color: #8f8f8f;
}

.pcg_right {
  position: absolute;
  right: 10px;
  top: 0.9rem;
  font-size: 1.7rem;
}

.pcg-block-left {
  flex: 0 0 40px;
  position: relative;
}

.pcg-block-right {
  flex: 1;
}

.pkg_desc {
  padding: 0 10px 10px 40px;
}

.pkg_container {
  padding: 10px 10px 4px 10px;
}

a.a_btn {
  display: block;
  padding: 2px;
  margin: 5px 0;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

a.a_btn.a_action {
  background-color: #6bb324;
  border: 2px solid #65ac20;  
  color: #ffffff;
}
a.a_btn.a_info {
  border: 2px solid #E20074;
  background-color: transparent;
  color: #E20074;
}
a.a_btn.a_action:active {
  border: 2px solid #58951c;
  background-color: #58951c;
}
a.a_btn.a_info:active{
  border: 2px solid #E20074;
  background-color: #E20074;
  color: #ffffff;
}

.pcg-title {
  text-transform: uppercase;
  width: 72%;
  display: inline-block;
}
.rAnchor {
  text-decoration: none;
}

</style>
